module.exports = __webpack_public_path__ + "static/img/make-a-wish.350f75e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DOM/FloatMenu/image/make-a-wish.svg
// module id = 397
// module chunks = 0